import { ArtifactContract } from '@terra/shared-contracts-artifact';
import { createTerraOrpcClient } from '@terra/shared-utils';

const SERVICE_NAME = 'ai';

export const artifactClient = createTerraOrpcClient({
  contract: ArtifactContract,
  serviceName: SERVICE_NAME,
});
